module.exports = __webpack_public_path__ + "assets/music/epic/Tale of the Ruins by Moonthief.ogg";